const columns = (t, showAdminRows) => [
  {
    key: 'expand',
    label: '',
    sortable: false,
    span: 1,
    align: 'center',
  },
  {
    key: 'orderNo',
    label: t('orderNo'),
    sortable: false,
    span: 2,
    align: 'center',
  },
  {
    key: 'ediOrderNo',
    label: t('internalOrderNo'),
    sortable: false,
    span: 2,
    align: 'center',
  },
  ...(showAdminRows
    ? [
        {
          key: 'admin',
          label: t('createdBy'),
          sortable: false,
          span: 2,
          align: 'center',
        },
      ]
    : []),
  {
    key: 'createdAt',
    label: t('orderCreatedAt'),
    sortable: true,
    align: 'center',
    span: 2,
  },
  {
    key: 'estimatedDelivery',
    label: t('estimatedDeliveryDate'),
    sortable: false,
    span: 2,
    align: 'center',
  },
  {
    key: 'department',
    label: t('department'),
    sortable: false,
    span: 2,
    align: 'center',
  },
  {
    key: 'status',
    label: t('status'),
    sortable: true,
    span: 2,
    align: 'center',
  },
  {
    key: 'price',
    label: t('totalAmount'),
    sortable: false,
    span: 2,
    align: 'center',
  },
];

export default columns;
